import { Link } from "react-router";
import { banner, profile } from "../assets";
import AboutSection from "../components/AboutSection";
import HeroSection from "../components/HeroSection";
import ProfessionalCredentials from "../components/ProfessionalCredentials";

const HomePage = () => {
    return (
        <div className="min-h-screen bg-red-800 text-gray-800">
            <HeroSection bgImage={banner} frontImage={profile}>
                <div className="text-left space-y-4 lg:space-y-6">
                    {/* Enhanced name with serif typography for authority */}
                    <h1 className="text-4xl lg:text-5xl xl:text-6xl font-serif font-bold text-heritage-ivory leading-tight">
                        Prof. Bihari Lal Sharma
                    </h1>
                    
                    {/* Enhanced title with emphasis on current positions */}
                    <div className="space-y-2">
                        <h2 className="text-xl lg:text-2xl xl:text-3xl font-sans font-semibold text-yellow-300">
                             Vice Chancellor, Sampurnanand Sanskrit University, Varanasi
                        </h2>
                    </div>
                    
                    {/* Enhanced mission statement */}
                    <div className="space-y-3">
                        
                        {/* University legacy highlight */}
                        <p className="text-base lg:text-lg text-yellow-300/90 font-sans">
                            Leading one of the world’s oldest Sanskrit universities, with a 234+ year legacy.
                        </p>
                    </div>
                    
                    {/* Enhanced call-to-action with smooth transitions */}
                    <div className="pt-4 lg:pt-6 flex flex-col sm:flex-row gap-4 lg:pl-5">
                        <Link
                            to="/career-highlights"
                            className="lg:ml-5 inline-flex items-center bg-gradient-to-r from-heritage-maroon to-red-700 text-heritage-ivory px-6 py-3 lg:px-8 lg:py-4 rounded-2xl font-sans font-semibold text-base lg:text-lg shadow-strong hover:shadow-heritage hover:from-red-700 hover:to-heritage-maroon transform hover:scale-105 transition-all duration-200 ease-out focus:ring-4 focus:ring-heritage-gold/30 focus:outline-none "
                            aria-describedby="cta-description"
                        >
                            Explore Career Highlights
                            <svg 
                                className="ml-2 w-5 h-5 transition-transform duration-200 group-hover:translate-x-1" 
                                fill="none" 
                                stroke="currentColor" 
                                viewBox="0 0 24 24"
                                aria-hidden="true"
                            >
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                            </svg>
                        </Link>
                        
                        <Link
                            to="/research"
                            className="inline-flex items-center bg-gradient-to-r from-primary-500 to-accent-500 text-white px-6 py-3 lg:px-8 lg:py-4 rounded-2xl font-sans font-semibold text-base lg:text-lg shadow-strong hover:shadow-heritage hover:from-accent-500 hover:to-primary-500 transform hover:scale-105 transition-all duration-200 ease-out focus:ring-4 focus:ring-heritage-gold/30 focus:outline-none"
                        >
                            Academic Publications
                            <svg 
                                className="ml-2 w-5 h-5 transition-transform duration-200 group-hover:translate-x-1" 
                                fill="none" 
                                stroke="currentColor" 
                                viewBox="0 0 24 24"
                                aria-hidden="true"
                            >
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                            </svg>
                        </Link>
                        
                        <p id="cta-description" className="sr-only">
                            Navigate to explore Prof. Sharma's academic contributions, vision, and publications
                        </p>
                    </div>
                    
                    
                </div>
            </HeroSection>
            
            <section aria-label="About and credentials sections">
                <AboutSection />
                <ProfessionalCredentials />
              
            </section>
        </div>
    );
};

export default HomePage;
